import { Box, Button, Typography } from "@mui/material";
import CustomContainer from "../../../../components/CustomContainer";
import { StyledSection } from "../../../../components/Section";

import hero_bg from '../../../../assets/hero_bg.jpg';
import hero_video from '../../../../assets/hero_video.mp4'; // Importa o vídeo
import { hero_content } from "../../../../data/general_texts";

export default function Hero() {
    return (
        <StyledSection sx={styles.section}>
            <CustomContainer>
                <Box id={'hero'} sx={styles.content}>
                    <Typography variant="subtitle1" sx={{ color: 'common.white' }}>
                        {hero_content.subtitle}
                    </Typography>
                    <Typography variant="h1" sx={styles.title}>
                        {hero_content.title}
                    </Typography>
                    <Button
                        target="_blank"
                        rel="noopener noreferrer"
                        href={hero_content.cta_link}
                        size="large"
                        variant="contained"
                        color="secondary"
                        sx={styles.cta}
                    >
                        {hero_content.cta}
                    </Button>
                </Box>
            </CustomContainer>

            {/* Exibe a imagem no mobile */}
            <Box
                component={'img'}
                src={hero_bg}
                alt=""
                sx={{
                    ...styles.background,
                    display: { xs: 'block', md: 'none' },
                }}
            />
            <Box sx={{ ...styles.gradientOverlay, display: { xs: 'block', md: 'none' } }} />

            {/* Exibe o vídeo no desktop com gradiente escuro */}
            <Box sx={styles.videoContainer}>
                <Box
                    component={'video'}
                    src={hero_video}
                    autoPlay
                    muted
                    loop
                    sx={styles.video}
                />
                <Box sx={styles.gradientOverlay} />
            </Box>
        </StyledSection>
    );
};

const styles = {
    section: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: { xs: 'auto', md: '90vh' },
        minHeight: { xs: '72dvh', md: '90vh' },
        overflow: 'hidden',
    },
    content: {
        py: { xs: '4.5rem', md: '11rem' },
        px: { xs: 1, md: 0 },
        zIndex: 1,
        textAlign: 'center',
        position: 'relative',
    },
    title: {
        color: 'common.white',
        mt: '1rem',
        mb: '2rem',
        textWrap: 'balance',
        maxWidth: 720,
        mx: 'auto',
    },
    cta: {
        whiteSpace: 'normal',
        maxWidth: '100%',
        px: { xs: 2, md: 5 },
    },
    background: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: -1,
    },
    videoContainer: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: { xs: 'none', md: 'block' },
        zIndex: -1,
    },
    video: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
    },
    gradientOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'linear-gradient(180deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0.7) 100%)',
        zIndex: 0,
    },
};
